import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Authors = React.lazy(() => import('./index'));
const AuthorTable = React.lazy(() => import('./authorTable'));
const Author = React.lazy(() => import('./author'));
const AuthorDetail = React.lazy(() => import('./authorDetail'));
const AddNewAuthor = React.lazy(() => import('./addNewAuthor'));
const EditAuthor = React.lazy(() => import('./editAuthor'));

export const useAuthorRoutes = () => {

    return (
        <Route path="authors" element={<Suspense fallback={<div>منتظر باشید...</div>}><Authors /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AuthorTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewAuthor/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Author/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><AuthorDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditAuthor/></Suspense> } />
            </Route>
        </Route>
    )
}